"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaceMixin = exports.paddingMixin = exports.marginMixin = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _propTypes = require("../prop-types");

var marginMixinBase = function marginMixinBase(_ref) {
  var margin = _ref.margin,
      theme = _ref.theme;

  if (margin === undefined) {
    return '';
  }

  var getValue = function getValue(value) {
    var themeValue = theme.selectors.space(value);
    return themeValue === null ? (0, _utils.px)(value) : (0, _utils.px)(themeValue);
  };

  if (typeof margin === 'number' || typeof margin === 'string') {
    return "margin: ".concat(getValue(margin), ";");
  } else if (margin instanceof Array) {
    return "margin: ".concat(margin.map(getValue).join(' '), ";");
  } else if ((0, _typeof2.default)(margin) === 'object') {
    var top = margin.top !== undefined ? getValue(margin.top) : undefined;
    var right = margin.right !== undefined ? getValue(margin.right) : undefined;
    var bottom = margin.bottom !== undefined ? getValue(margin.bottom) : undefined;
    var left = margin.left !== undefined ? getValue(margin.left) : undefined;
    return "\n      ".concat(left === undefined ? '' : "margin-left: ".concat(left, ";"), "\n      ").concat(right === undefined ? '' : "margin-right: ".concat(right, ";"), "\n      ").concat(top === undefined ? '' : "margin-top: ".concat(top, ";"), "\n      ").concat(bottom === undefined ? '' : "margin-bottom: ".concat(bottom, ";"), "\n    ");
  }

  return '';
};

var marginMixin = (0, _stencilReactDesc.describe)(marginMixinBase).description('Adds a prop for setting margins.');
exports.marginMixin = marginMixin;
marginMixin.propTypes = {
  margin: (0, _propTypes.cssMargin)().description("Sets the CSS 'margin' property for the element.")
};

var paddingMixinBase = function paddingMixinBase(_ref2) {
  var padding = _ref2.padding,
      theme = _ref2.theme;

  if (padding === undefined) {
    return '';
  }

  var getValue = function getValue(value) {
    var themeValue = theme.selectors.space(value);
    return themeValue === null ? (0, _utils.px)(value) : (0, _utils.px)(themeValue);
  };

  if (typeof padding === 'number' || typeof padding === 'string') {
    return "padding: ".concat(getValue(padding), ";");
  } else if (padding instanceof Array) {
    return "padding: ".concat(padding.map(getValue).join(' '), ";");
  } else if ((0, _typeof2.default)(padding) === 'object') {
    var top = padding.top !== undefined ? getValue(padding.top) : undefined;
    var right = padding.right !== undefined ? getValue(padding.right) : undefined;
    var bottom = padding.bottom !== undefined ? getValue(padding.bottom) : undefined;
    var left = padding.left !== undefined ? getValue(padding.left) : undefined;
    return "\n      ".concat(left === undefined ? '' : "padding-left: ".concat(left, ";"), "\n      ").concat(right === undefined ? '' : "padding-right: ".concat(right, ";"), "\n      ").concat(top === undefined ? '' : "padding-top: ".concat(top, ";"), "\n      ").concat(bottom === undefined ? '' : "padding-bottom: ".concat(bottom, ";"), "\n    ");
  }

  return '';
};

var paddingMixin = (0, _stencilReactDesc.describe)(paddingMixinBase).description('Adds a prop for setting padding.');
exports.paddingMixin = paddingMixin;
paddingMixin.propTypes = {
  padding: (0, _propTypes.cssPadding)().description("Sets the CSS 'padding' property for the element.")
};
var spaceMixin = (0, _utils.combineMixins)(marginMixin, paddingMixin);
exports.spaceMixin = spaceMixin;